const KEY = 'pill_permission_recovery_draft';
const EVENT = 'kkomok-permission-checkpoint';
const MAX_AGE_MS = 60 * 60 * 1000;
const PATH = '/medications/new-bundle';

export function clearPermissionDraft() {
    try { localStorage.removeItem(KEY); } catch (_) {}
}
export function readPermissionDraft(uuid, path = null) {
    try {
        const raw = localStorage.getItem(KEY);
        if (raw?.length > 180000) { clearPermissionDraft(); return null; }
        const draft = JSON.parse(raw);
        if (!draft) return null;
        if (draft.version !== 1 || draft.uuid !== uuid || !draft.payload
            || draft.path?.split('?')[0] !== PATH || Date.now() - draft.at > MAX_AGE_MS
            || draft.at > Date.now() || typeof draft.at !== 'number'
            || typeof draft.payload !== 'object' || Array.isArray(draft.payload)
            || (draft.payload.medications !== undefined && (!Array.isArray(draft.payload.medications)
                || draft.payload.medications.length > 200
                || draft.payload.medications.some(m => !m || typeof m.name !== 'string')))
            || (draft.payload.times !== undefined && (!Array.isArray(draft.payload.times)
                || draft.payload.times.some(t => typeof t !== 'string')))
            || (draft.payload.entryMode !== undefined && !['manual', 'photo', 'review'].includes(draft.payload.entryMode))
            || (draft.payload.manualStep !== undefined && !['names', 'period', 'reminder', 'schedule'].includes(draft.payload.manualStep))
            || (path && path !== draft.path)) {
            clearPermissionDraft();
            return null;
        }
        return draft;
    } catch (_) { clearPermissionDraft(); return null; }
}
export function savePermissionDraft(uuid, path, payload) {
    if (!uuid || path.split('?')[0] !== PATH) return false;
    try {
        // Browser object URLs and files do not survive OS termination. Never persist
        // prescription pixels or analysis consent as permission-recovery data.
        const clean = JSON.parse(JSON.stringify(payload, (key, value) => {
            if (/^(imageFile|imagePreview|imageLoading|base64|dataUrl|photoConsent)$/.test(key)) return undefined;
            if (typeof value === 'string' && /^(blob:|data:image\/)/.test(value)) return undefined;
            if ((typeof Blob !== 'undefined' && value instanceof Blob)) return undefined;
            return value;
        }));
        const raw = JSON.stringify({ version: 1, uuid, path, at: Date.now(), payload: clean });
        if (raw.length > 180000) return false;
        localStorage.setItem(KEY, raw);
        return true;
    } catch (_) { return false; }
}
export function checkpointPermissionDraft() {
    window.dispatchEvent(new Event(EVENT));
}
export const permissionCheckpointEvent = EVENT;
